'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllChildren = exports.getFullEntity = exports.buildFullEntity = exports.pickRefNodes = exports.getGraphNode = exports.getEntity = exports.entitySelector = exports.entityTypeSelector = exports.selectGraph = exports.GRAPH_KEY = undefined;

var _property2 = require('lodash/property');

var _property3 = _interopRequireDefault(_property2);

var _nthArg2 = require('lodash/nthArg');

var _nthArg3 = _interopRequireDefault(_nthArg2);

var _mapValues2 = require('lodash/mapValues');

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _identity2 = require('lodash/identity');

var _identity3 = _interopRequireDefault(_identity2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _filter2 = require('lodash/filter');

var _filter3 = _interopRequireDefault(_filter2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

exports.fullEntitySelector = fullEntitySelector;
exports.allChildrenSelector = allChildrenSelector;
exports.filterEntity = filterEntity;

var _capeLodash = require('cape-lodash');

var _reselect = require('reselect');

var _capeSelect = require('cape-select');

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GRAPH_KEY = exports.GRAPH_KEY = 'graph2';
var fpSelect = (0, _curry3.default)(_capeSelect.select, 2);
var selectGraph = exports.selectGraph = (0, _property3.default)(GRAPH_KEY);
var entityTypeSelector = exports.entityTypeSelector = fpSelect(selectGraph);
var entitySelector = exports.entitySelector = (0, _flow3.default)(_helpers.getPath, fpSelect(selectGraph));
var getEntity = exports.getEntity = (0, _curry3.default)(function (state, entity) {
  return entitySelector(entity)(state);
});

var getGraphNode = exports.getGraphNode = (0, _curry3.default)(function (graph, node) {
  return (0, _get3.default)(graph, (0, _helpers.getPath)(node), node);
});
var pickRefNodes = exports.pickRefNodes = (0, _curry3.default)(function (deep, graph, refs) {
  if (!refs) return {};
  if (deep) return (0, _mapValues3.default)(refs, (0, _flow3.default)(getGraphNode(graph), buildFullEntity(deep - 1, graph))); // eslint-disable-line
  return (0, _mapValues3.default)(refs, getGraphNode(graph));
});
// Get one level of REF fields.
var buildFullEntity = exports.buildFullEntity = (0, _curry3.default)(function (deep, graph, node) {
  if (!node || (0, _isEmpty3.default)(node[_helpers.REF]) && (0, _isEmpty3.default)(node[_helpers.REFS])) return (0, _helpers.rmRefs)(node);
  var getPredRefs = function getPredRefs(predRefs) {
    return (0, _mapValues3.default)(predRefs, (0, _flow3.default)(getGraphNode(graph), deep ? buildFullEntity(deep, graph) : _identity3.default));
  };
  return (0, _capeLodash.merge)((0, _helpers.rmRefs)(node), pickRefNodes(deep, graph, node[_helpers.REF]), node[_helpers.REFS] ? (0, _mapValues3.default)(node[_helpers.REFS], getPredRefs) : {});
});
// (state, entityObj) simpleSelector
var getFullEntity = exports.getFullEntity = (0, _reselect.createSelector)(selectGraph, (0, _nthArg3.default)(1), buildFullEntity(0));
var getAllChildren = exports.getAllChildren = (0, _reselect.createSelector)(selectGraph, (0, _nthArg3.default)(1), buildFullEntity(7));
function fullEntitySelector(customEntitySelector) {
  return (0, _capeSelect.simpleSelector)((0, _nthArg3.default)(0), customEntitySelector, getFullEntity);
}
function allChildrenSelector(customEntitySelector) {
  return (0, _capeSelect.simpleSelector)((0, _nthArg3.default)(0), customEntitySelector, getAllChildren);
}

function filterEntity(type, predicate) {
  return (0, _reselect.createSelector)(entityTypeSelector(type), function (items) {
    return (0, _filter3.default)(items, predicate);
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-graph/lib/select.js
// module id = 1292
// module chunks = 0